'use client';

import FiveStars from '@/components/FiveStars';
import { useYotpoReviewsContext } from '@/context/YotpoContext';

export const SwabKitProductDetailsYotpoShort: React.FC = () => {
  const { yotpoResponse } = useYotpoReviewsContext();

  return (
    <div className="flex justify-start items-center mb-4">
      <FiveStars score={yotpoResponse?.average_score} className="me-2" />
      <div className="leading-[22.4px] tracking-[-0.48px]">
        <span className="me-1">{yotpoResponse?.average_score}</span>
        <span className="me-1">&bull;</span>
        <span className="font-light">{yotpoResponse?.total_reviews} reviews</span>
      </div>
    </div>
  );
};
